import { useEffect } from "react";
import { Outlet } from "react-router";
import { useMe } from "@/api/hooks";
import { CommandPalette } from "@/components/CommandPalette";
import { setLocale } from "@/i18n";
import { useThemeMode } from "@/lib/theme";

/** Signed-in layout without the sidebar, for focused work such as the test runner. */
export function FocusShell() {
  const me = useMe();
  useThemeMode(me.theme_mode);
  useEffect(() => setLocale(me.locale), [me.locale]);
  return (
    <main className="flex min-h-screen min-w-0 flex-col">
      <Outlet />
      <CommandPalette />
    </main>
  );
}
